import {
  EoDropdownConfig,
  IEoDropdownConfig,
} from '../eo-dropdown/eo-dropdown.model';
import { Specialty } from './specialty.model';

export interface IEoSpecialtyDropdownConfig extends IEoDropdownConfig<Specialty> {
  type?: any;
}

export class EoSpecialtyDropdownConfig
  extends EoDropdownConfig<Specialty>
  implements IEoSpecialtyDropdownConfig
{
  override type?: any;

  constructor();
  constructor(obj: IEoSpecialtyDropdownConfig);
  constructor(obj?: IEoSpecialtyDropdownConfig) {
    super(obj as IEoSpecialtyDropdownConfig);
    this.type = 'specialtyDropdown';
  }
}
